import { LitElement, html, css } from 'lit';
import { jhaStyles } from '../../styles/jha-styles.js';

const styles = css`
  :host {
    display: block;
  }
  :host {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  progress {
    width: var(--jha-progress-linear-width, 180px);
    max-width: 100%;
    height: var(--jha-progress-linear-height, 8px);
  }
  progress {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none; // remove Firefox and Opera border
    border: 0; // IE10 uses \`color\` to set the bar background-color
    color: var(
      --jha-progress-linear-progress-text,
      var(--jha-color-success, #4caf50)
    );
  }
  progress::-webkit-progress-bar {
    background-color: var(
      --jha-progress-linear-background,
      var(--jha-color-gray-light, #e4e7ea)
    );
    border-radius: var(--jha-progress-linear-border-radius, 2px);
  }
  progress[value]::-webkit-progress-value {
    background-color: var(
      --jha-progress-linear-value-background,
      var(--jha-color-success, #4caf50)
    );
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
  }
  progress[value='100']::-webkit-progress-value {
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
  }
  @-moz-document url-prefix() {
    progress {
      border-width: 0;
      background-color: var(
        --jha-progress-linear-background,
        var(--jha-color-gray-light, #e4e7ea)
      );
      border-radius: 2px;
    }
    progress[value]::-moz-progress-bar {
      background-color: var(
        --jha-progress-linear-value-background,
        var(--jha-color-success, #4caf50)
      );
      border-top-left-radius: 2px;
      border-bottom-left-radius: 2px;
    }
    progress[value='100']::-moz-progress-bar {
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
    }
  }
  span {
    display: var(--jha-progress-linear-span-display, none);
    margin-left: 12px;
    font-size: var(
      --jha-progress-linear-span-size,
      var(--jha-text-size-base, 14) - 1
    );
    color: var(--jha-progress-linear-span, var(--jha-color-neutral, #8d99a0));
  }
`;

export default class JhaProgressLinear extends LitElement {
  static get styles() {
    return [jhaStyles, styles];
  }

  static get properties() {
    return {
      percentage: {
        type: String,
        notify: true,
      },
    };
  }

  constructor() {
    super();
    this.percentage = '';
  }

  render() {
    return html`
      <progress .value="${this.percentage}" max="100"></progress>
      <span>${this.percentage}%</span>
    `;
  }
}

export { styles as JhaProgressLinearStyles };
